"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
const RedeemViewStyled_1 = __importDefault(require("../redeem/RedeemViewStyled"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default(RedeemViewStyled_1.default) `
    padding: 10px 0;
    min-height: 100vh;
    .load-diamond {
        background-color: #000;
        outline: 5px solid #000;
    }
    .inviteLoading {
        @media screen and ${constants_1.Device.laptop} {
            min-height: 100vh;
        }
    }
    @media screen and ${constants_1.Device.laptop} {
        min-height: auto;
        padding: 0 0 50px;
    }
    @media screen and ${constants_1.Device.mobileL} {
        padding: 0 0 24px;
    }
`;
//# sourceMappingURL=InviteViewStyled.js.map